import React, { useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import useClickOutside from "~utils/hooks/useClickOutside";
import {
  Overlay,
  ModalContainer,
  CloseIconWrapper,
  CloseIcon,
  Modal as StyledModal,
  ModalContent,
} from "./styledComponents";

export type Props = {
  children: React.ReactNode;
  show: boolean;
  onClose: (e: React.MouseEvent | MouseEvent) => void;
};

const Modal = ({ children, show, onClose }: Props) => {
  const modalContentRef = useRef<HTMLDivElement | null>(null);
  const modalRootRef = useRef(document.createElement("div"));
  const modalContentNodeRef = useRef(document.createElement("div"));

  useClickOutside(modalContentRef, onClose);
    useEffect(() => {
      document.body.appendChild(modalRootRef.current);
      modalRootRef.current.appendChild(modalContentNodeRef.current);

      return () => {
        modalRootRef.current.remove();
      };
    }, []);

  const modal = (
    <Overlay show={show}>
      {show && (
        <ModalContainer ref={modalContentRef}>
          <StyledModal>
            <CloseIconWrapper>
              <CloseIcon size={20} onClick={onClose} color="black" />
            </CloseIconWrapper>
            <ModalContent>{children}</ModalContent>
          </StyledModal>
        </ModalContainer>
      )}
    </Overlay>
  );

  return ReactDOM.createPortal(modal, modalContentNodeRef.current);
};

export default Modal;
